export enum LandlineProviderEnum {
  TELENET = 'Telenet',
  VOO = 'VOO',
  PROXIMUS = 'Proximus',
  ALL = 'ALL',
}
